"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _index = require("../../index");
var _newComponents = require("../../new-components");
var _getClassName = function _getClassName(status) {
  if (status === 'paid') {
    return _newComponents.PILL_TYPES.SUCCESS_INVERT;
  }
  if (status === 'overdue') {
    return _newComponents.PILL_TYPES.ERROR;
  }
  return _newComponents.PILL_TYPES.ORANGE;
};
var BookingListDeadlines = function BookingListDeadlines(_ref) {
  var order = _ref.order;
  var deadlines = _index.bookingHelpers.getDeadlinesWithStatus(order);
  return /*#__PURE__*/_react["default"].createElement(_newComponents.Table, null, /*#__PURE__*/_react["default"].createElement(_newComponents.TableHead, null, /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Item"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Due date"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Status")), /*#__PURE__*/_react["default"].createElement("tbody", null, deadlines.map(function (deadline) {
    return /*#__PURE__*/_react["default"].createElement(_newComponents.TableRow, null, /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, deadline.name, " instalment"), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, (0, _moment["default"])(deadline.dueDate).format('D MMM')), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, /*#__PURE__*/_react["default"].createElement(_newComponents.Pill, {
      title: deadline.status || 'pending',
      type: _getClassName(deadline.status)
    })));
  })));
};
BookingListDeadlines.propTypes = {
  order: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = BookingListDeadlines;